/* global ClipboardItem */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getOrder } from 'redux/actions/order-actions';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import User from 'helper/User';
import { Link } from 'react-router-dom'
import { getOrdersResourcesByRole } from 'redux/actions/agency-resource-actions';
import { returnDynamicURL } from 'helper/helperFunctions';
import { reportService } from '../../../services/report';
import { orderService } from '../../../services/order';
import { basePathApi } from '../../../helper/basePathApi';
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';

class PhotoAndVideo extends Component {
    constructor(props) {
        super(props)
        if (!User.isAuthenticated()) {
            this.props.history.push('/');
        }
        // console.log('poarams', this.props.match.params);
        if (User.isAuthenticated()) {
            this.props.getOrderCall(this.props.order_details.id);
            this.props.getOrderVideos(this.props.order_details.id);
        }
        this.state = {
            order_details: OC.ORDERDETAIL
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.order_details !== prevProps.order_details) {
            this.setState({
                order_details: this.props.order_details
            });
        }
    }
    downloadFile = (file, video_type) => {
        orderService.getVideoDownloadLink({file: file}).then(
            res => {
                window.open(res.url, '_blank');
                this.saveVideoCount('download', video_type);
            }
        )
    }
    saveVideoCount = (track_type, video_type) => {
        const data ={
            order_id: this.props.order_details.id,
            track_type: track_type,
            device_type: 'web',
            video_type: video_type,
            user_id: User.user.id
            // user_id: User.order('id')
        };
        reportService.saveVideoCount(data);
    }
    copyLinkAsHtml = (type) => {
        const { order_details } = this.props;

        // if (!order_details?.barcode) return;

        const url = `${basePathApi}v/${order_details.barcode}/${type}`;
        const label = `${order_details.barcode}/${type}`;

        const html = `<a href="${url}" target="_blank">${label}</a>`;
        const text = url;

        const blobHtml = new Blob([html], { type: 'text/html' });
        const blobText = new Blob([text], { type: 'text/plain' });

        navigator.clipboard.write([
            new ClipboardItem({
                'text/html': blobHtml,
                'text/plain': blobText
            })
        ]);
    };
    render() {

        const { orderResources } = this.props;
        const { order_details } = this.state;
        let link = returnDynamicURL(typeof order_details.agency.single_account === 'undefined' ||
        !order_details.  agency.single_account ? null : order_details.agency.single_account.account.domain_slug,
        order_details.photo_admin_username, order_details.photo_admin_password);

        return (
            <div className="form_tile">
               <div className="form_tile_heading">
                    <img src="https://gtvoriginalimages.s3.amazonaws.com/static/img/upload_image.png" height="27" alt="Products &amp; Pricing" /><span>Photos &amp; Videos</span>
               </div>
               <div className="form_tile_content">
                  <div className="reponsive-table form_tile_row">
                    <Link className="blue_link" target='_blank' to={`/image-gallery/${order_details.id}`}><i className="fa fa-image" /> Photo Gallery</Link>
                    {
                        Number(order_details.settings.finalize_by_qa.value)
                        ?
                        <span style={{float: 'right'}}>
                            <Link target='_blank' className='blue_link' to={`/print-order-summary/${order_details.id}`}><i className='fa fa-print'></i> Print Summary</Link>
                        </span>
                        :
                            null
                    }
                    <table style={{width: '100%'}} className="table_tile">
                        <tbody>
                            <tr>
                                <td>
                                    <div style={{ paddingTop: '15px' }}>
                                        {/* <Link className="blue_link" to={returnDynamicURL(typeof order_details.agency.single_account === 'undefined' ||
                                            !order_details.  agency.single_account ? null : order_details.agency.single_account.account.domain_slug,
                                            order_details.photo_admin_username, order_details.photo_admin_password)}
                                        >
                                            {returnDynamicURL(typeof order_details.agency.single_account === 'undefined' ||
                                            !order_details.agency.single_account ? null : order_details.agency.single_account.account.domain_slug,
                                            order_details.photo_admin_username, order_details.photo_admin_password)}
                                        </Link> */}
                                        <a class="blue_link" target="_blank" style={{cursor: "pointer"}} href={`microsoft-edge:${link}`}>{link}</a>
                                         {/* (Quick Login Link) */}
                                         &nbsp;(
                                         <a class="blue_link" target="_blank" style={{cursor: "pointer"}} href={`microsoft-edge:${link}`}>Quick Login Link</a>
                                         )
                                    </div>
                                    <p className="text_12 text-muted dark">
                                        Note: You can use the above Quick Login Link to provide to potential customers
                                        to give them an example of the Group Travel videos Photo Gallery and finished
                                        Videos
                                </p>
                                </td>
                            </tr>
                            {
                                'highlight_video' in orderResources &&
                                <tr>
                                    <td>
                                        {/* <DownloadFile extraClass='blue_link' multiple={false} title={'Download Highlight Video (' + (orderResources.highlight_video.file_size / 1024 / 1024).toFixed(2) + ') MB'} files={{ */}
                                        {/* <DownloadFile extraClass='linkColor downloadHighlightVideo' space={'&nbsp;&nbsp;&nbsp;'} multiple={false} title={'Download Highlight Video'} files={{
                                            'file_title': orderResources.highlight_video.file_title,
                                            'file_path': orderResources.highlight_video.file_path
                                        }} /> */}
                                        <button className="orderDetailsAction downloadIcon linkColor downloadHighlightVideo" onClick={() => {this.downloadFile(orderResources.highlight_video.file_path, 'highlight')}}>&nbsp;&nbsp;&nbsp;Download Highlight Video</button>
                                        <OverlayTrigger placement='top' overlay={<Popover id='copyLinkMaterial' >Copy Highlight Video Address</Popover>} >
                                            {/* <CopyToClipboard text={basePathApi + 'v/' + order_details.barcode + '/highlight_video'}> */}
                                                <button onClick={() => this.copyLinkAsHtml('highlight_video')} className="orderDetailsAction copyColorAction ml-lg" type="button">
                                                    <span className="">&nbsp;</span>
                                                </button>
                                            {/* </CopyToClipboard> */}
                                        </OverlayTrigger>
                                        <p className="text_12 text-muted dark">
                                            Note: If the download button doesn’t work, try right-clicking and selecting “Save Link As” (or “Save Target As”).
                                            You can also use the link icon to copy the video URL — share it via email or open it directly in your browser to play the video online without downloading.
                                        </p>
                                    </td>
                                </tr>
                            }
                            {
                                'full_video' in orderResources &&
                                <tr>
                                    <td>
                                        {/* <DownloadFile extraClass='linkColor downloadVideo' space={'&nbsp;&nbsp;&nbsp;'} multiple={false} title={'Download Full Video'} files={{
                                            'file_title': orderResources.full_video.file_title,
                                            'file_path': orderResources.full_video.file_path
                                        }} /> */}
                                        <button className="orderDetailsAction downloadIcon linkColor downloadHighlightVideo" onClick={() => {this.downloadFile(orderResources.full_video.file_path, 'full')}}>&nbsp;&nbsp;&nbsp;Download Full Video</button>
                                        <OverlayTrigger placement='top' overlay={<Popover id='copyLinkMaterial' >Copy Full Video Address</Popover>} >
                                            {/* <CopyToClipboard text={basePathApi + 'v/' + order_details.barcode + '/full_video'}> */}
                                                <button onClick={() => this.copyLinkAsHtml('full_video')} className="orderDetailsAction copyColorAction ml-lg" type="button">
                                                    <span className="">&nbsp;</span>
                                                </button>
                                            {/* </CopyToClipboard> */}
                                        </OverlayTrigger>
                                        <p className="text_12 text-muted dark">
                                            Note: If the download button doesn’t work, try right-clicking and selecting “Save Link As” (or “Save Target As”).
                                            You can also use the link icon to copy the video URL — share it via email or open it directly in your browser to play the video online without downloading.
                                        </p>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                  </div>
               </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const {
        order_details,
        orderResources
    } = state.ordersReducer;
    const { orderItems } = state.ordersReducer;
    return {
        order_details,
        orderResources
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getOrderCall: (id) => { dispatch(getOrder(id)) },
        getOrderVideos: (orderId) => { dispatch(getOrdersResourcesByRole(orderId)) },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoAndVideo);
